package com.wintermar.inspection.core.ui.theme.color

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.BrandPrimaryColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.BrandSecondaryColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.ErrorColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.InfoColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.NeutralColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.SuccessColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.WarningColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.BlueColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.GreenColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.LimeColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.MagentaColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.OrangeColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.PurpleColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.RedColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.TealColorVariant
import com.wintermar.inspection.core.ui.theme.color.palette.accent.YellowColorVariant

object ColorPalette {
    object Accent {
        val Blue: ColorVariant = BlueColorVariant
        val Lime: ColorVariant = LimeColorVariant
        val Magenta: ColorVariant = MagentaColorVariant
        val Orange: ColorVariant = OrangeColorVariant
        val Purple: ColorVariant = PurpleColorVariant
        val Red: ColorVariant = RedColorVariant
        val Teal: ColorVariant = TealColorVariant
        val Yellow: ColorVariant = YellowColorVariant
        val Green: ColorVariant = GreenColorVariant
    }

    object Basic {
        val black = Color.Black
        val white = Color.White
    }

    object Brand {
        val Primary: ColorVariant = BrandPrimaryColorVariant
        val Secondary: ColorVariant = BrandSecondaryColorVariant
    }

    val Error: ColorVariant = ErrorColorVariant
    val Info: ColorVariant = InfoColorVariant
    val Neutral: ColorVariant = NeutralColorVariant
    val Success: ColorVariant = SuccessColorVariant
    val Warning: ColorVariant = WarningColorVariant
}
